import React from "react";
import { AlertTriangle, ChevronRight, CalendarRange } from "lucide-react";
import { Avatar } from "./AvatarStack";
import { monthPct, periodLabel } from "./allocUtils";

export function TeamList({ rows, load, pmId, onOpen }) {
  if (!rows.length) {
    return (
      <div className="py-10 text-center text-sm text-ink-muted border border-dashed border-neutral-200 rounded-xl" data-testid="team-empty">
        Încă nu există membri în echipă. Adaugă primii colegi cu butonul de mai sus.
      </div>
    );
  }
  return (
    <div className="divide-y divide-neutral-100 border border-neutral-200 rounded-xl overflow-hidden bg-white" data-testid="team-list">
      {rows.map((a) => {
        const now = monthPct(a);
        const total = load[a.employee_id] || 0;
        const over = total > 100;
        const fee = a.hourly_rate_override ?? a.employee?.hourly_fee_rate;
        return (
          <button key={a.id} type="button" onClick={() => onOpen(a)} data-testid={`team-row-${a.id}`}
            className="w-full text-left flex items-center gap-3 px-4 py-3 hover:bg-slate-50 transition-colors group">
            <Avatar id={a.employee_id} name={a.employee?.name} size={36} ring={false} />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium text-sm text-ink truncate">{a.employee?.name}</span>
                {pmId === a.employee_id && <span className="px-1.5 py-px rounded bg-brand/10 text-brand text-[10px] font-semibold">PM</span>}
              </div>
              <div className="text-[12px] text-ink-muted truncate flex items-center gap-1.5">
                {a.employee?.job_title || "—"} · {a.allocation_periods?.length ? <CalendarRange className="h-3 w-3" /> : null}{periodLabel(a)}
              </div>
            </div>
            <div className="hidden sm:block text-right w-24">
              <div className="font-mono text-[9px] uppercase tracking-widest text-ink-muted">Tarif</div>
              <div className="text-sm tabular-nums" data-testid={`asg-fee-${a.id}`}>{fee != null ? `${Number(fee).toFixed(0)} €/h` : "—"}</div>
            </div>
            <div className="text-right w-20 sm:w-28 shrink-0">
              <div className="font-mono text-[9px] uppercase tracking-widest text-ink-muted">Luna aceasta</div>
              <div className="font-display font-bold text-ink tabular-nums" data-testid={`asg-pct-${a.id}`}>{now}%</div>
              <div className={`text-[10px] tabular-nums flex items-center justify-end gap-1 ${over ? "text-red-600 font-semibold" : "text-ink-muted"}`} data-testid={`asg-load-${a.id}`}>
                {over && <AlertTriangle className="h-3 w-3" />} total {total}%
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-neutral-300 group-hover:text-brand transition-colors shrink-0" />
          </button>
        );
      })}
    </div>
  );
}
